// look for original source code in shikimori
import delay from 'delay';

export default function showModal({
  $modal,
  $trigger,
  $outerNode,
  show,
  hide,
  isHiddenCheck,
  clickEventName = 'click'
}) {
  let ignoreNextEvent = false;
  // bumped on every teardown, so a delayed handler registration still in flight knows it is stale
  let bindGeneration = 0;

  function checkHidden() {
    return isHiddenCheck ?
      isHiddenCheck() :
      $modal.css('display') === 'none';
  }

  function toggleModal({ type }) {
    const eventName = checkHidden() || type === 'focus' ?
      'modal:show' :
      'modal:hide';

    if (ignoreNextEvent) { return; }

    $modal.trigger(eventName);

    // to prevent immediately click after focus
    ignoreNextEvent = true;
    delay().then(() => ignoreNextEvent = false);
  }

  function tryCloseModal(e) {
    const $target = $(e.target);
    const isInside = e.target === ($outerNode || $modal)[0] ||
      $target.closest($outerNode || $modal).length;
    const isTrigger = $trigger &&
      ($target.closest($trigger).length || e.target === $trigger[0]);

    if (isInside || isTrigger || !$target.parents('html').length) { return; }

    $modal.trigger('modal:hide');
  }

  function closeModalOnEsc({ keyCode }) {
    if (keyCode !== 27) {
      return;
    }

    $modal.trigger('modal:hide');
  }

  function unbindHandlers() {
    bindGeneration += 1;
    $(document.body).off(clickEventName, tryCloseModal);
    $(document.body).off('focus', '*', tryCloseModal);
    $(document.body).off('keydown', closeModalOnEsc);
  }

  // hide leaves the trigger bound — the modal must reopen on the next click; only destroy
  // releases it, otherwise every teardown leaves a toggle of a dead modal on the trigger
  function destroy() {
    unbindHandlers();
    $trigger?.off(clickEventName, toggleModal);
  }

  $trigger?.on(clickEventName, toggleModal);

  $modal
    .on('modal:show', e => {
      e.stopPropagation();
      if (!checkHidden()) { return; }

      // fixes issue with developer tools click causing modal to hide after modal was just shown
      $trigger?.blur();

      if (show) {
        show();
      } else {
        $modal.show();
      }

      const generation = bindGeneration;

      delay().then(() => {
        // hidden or destroyed while this registration was pending — binding now would leave
        // the handlers of a stale modal on the document
        if (generation !== bindGeneration) { return; }

        $(document.body).on(clickEventName, tryCloseModal);
        $(document.body).on('focus', '*', tryCloseModal);
        $(document.body).on('keydown', closeModalOnEsc);

        $(document).one('turbolinks:before-cache', () => {
          if (!checkHidden()) {
            $modal.trigger('modal:hide');
          }
          unbindHandlers();
        });
      });
    })
    .on('modal:hide', e => {
      // the event must not reach a modal this one is nested in
      e.stopPropagation();
      if (checkHidden()) { return; }

      if (hide) {
        hide();
      } else {
        $modal.hide();
      }

      unbindHandlers();

      if ($trigger?.is(':focus')) {
        $trigger.blur();
      }
    });

  return {
    $modal,
    $trigger,
    $outerNode,
    show() {
      $modal.trigger('modal:show');
      return this;
    },
    hide() {
      if (checkHidden()) { return; }

      $modal.trigger('modal:hide');
      return this;
    },
    destroy
  };
}
